import React from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

import { ItemContainer, FaqRTE } from '../styles/faqs-item.style';

const defaultProps = {
  answer: '',
  question: '',
};

const propTypes = {
  answer: PropTypes.string,
  question: PropTypes.string,
};

/**
 * FAQ Block Component
 */
class FaqItem extends React.Component {
  /**
   * Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      height: 0,
    };
  }

  /**
   * Togles the state open or closed
   */
  toggle() {
    this.setState(prevState => ({
      height: prevState.height === 0 ? 'auto' : 0,
    }));
  }

  /**
   * Renders the FAQ Component
   * @returns {XML} FAQ Block Component
   */
  render() {
    const { question, answer, longAnswer } = this.props;
    const { height } = this.state;
    let markdown;
    if (longAnswer && longAnswer.childMarkdownRemark && longAnswer.childMarkdownRemark.html) {
      markdown = longAnswer.childMarkdownRemark.html;
    }
    return (
      <ItemContainer
        onClick={() => {
          this.toggle();
        }}
        onKeyDown={(e) => {
          if (e.which === 13 || e.keyCode === 13) this.toggle();
        }}
        role="button"
        tabIndex="0"
      >
        <div className="content">
          <div className="bullet">Q</div>
          <div className="question">{question}</div>
        </div>
        <AnimateHeight
          duration={500}
          height={height}
        >
          {
            longAnswer ? (
              <FaqRTE dangerouslySetInnerHTML={{ __html: markdown }} />
            ) : (
              <div className="faqs__answer">
                {answer}
              </div>
            )
          }
        </AnimateHeight>
      </ItemContainer>
    );
  }
}

FaqItem.defaultProps = defaultProps;
FaqItem.propTypes = propTypes;

export default FaqItem;



// WEBPACK FOOTER //
// ./src/components/faq/components/faqs-item.js